import {useDateFormat} from '@vueuse/core';

import {
  useNormalizer,
} from '@sttedra_ui/framework';

const {getDate} = useNormalizer();

function transformTimestampString(date) {
  if (!getDate(date)) return '';
  const localeNavigator = window.navigator.language;
  return useDateFormat(date, 'DD-MM-YYYY HH:mm:ss', {locales: localeNavigator}).value;
}

function transformTimestampWhithOutHour(date) {
  if (!getDate(date)) return '';
  const localeNavigator = window.navigator.language;
  return useDateFormat(date, 'DD-MM-YYYY', {locales: localeNavigator}).value;
}

function transformToISO(date) {
  if (!getDate(date)) return '';
  const normalizedDate = new Date(getDate(date));
  return normalizedDate.toISOString();
}

function parseDateWithoutTimeZone(dateString) {
  // Dividir la fecha y la hora por la "T"
  const parts = dateString.split('T');
  const datePart = parts[0]; // '2024-06-06'
  const timePart = parts[1]; // '14:48:18.792'

  // Dividir la fecha en año, mes y día
  const dateComponents = datePart.split('-');
  const year = parseInt(dateComponents[0], 10);
  const month = parseInt(dateComponents[1], 10) - 1; // Meses en JS son base 0
  const day = parseInt(dateComponents[2], 10);

  // Dividir el tiempo en hora, minutos, segundos y opcionalmente milisegundos
  const timeComponents = timePart.split(':');
  const hour = parseInt(timeComponents[0], 10);
  const minute = parseInt(timeComponents[1], 10);
  const secondAndMillisecond = timeComponents[2].split('.');
  const second = parseInt(secondAndMillisecond[0], 10);
  const millisecond = secondAndMillisecond[1] ? parseInt(secondAndMillisecond[1], 10) : 0;

  return {
    year: year,
    month: month,
    day: day,
    hour: hour,
    minute: minute,
    second: second,
    millisecond: millisecond,
  };
}

function transformTimestampStringNotDate(date) {
  if (!getDate(date)) return '';

  const {
    year,
    month,
    day,
    hour,
    minute,
    second,
  } = parseDateWithoutTimeZone(date);

  // eslint-disable-next-line max-len
  return `${String(day).padStart('2', '0')}/${String(month + 1).padStart('2', '0')}/${year} ${String(hour).padStart('2', '0')}:${String(minute).padStart('2', '0')}:${String(second).padStart('2', '0')}`;
}

function transformTimestampStringNotDateWhithOutHour(date) {
  if (!getDate(date)) return '';

  const {
    year,
    month,
    day,
  } = parseDateWithoutTimeZone(date);

  return `${String(day).padStart('2', '0')}/${String(month + 1).padStart('2', '0')}/${year}`;
}

const result = Object.freeze({
  transformTimestampString,
  transformTimestampWhithOutHour,
  transformToISO,
  parseDateWithoutTimeZone,
  transformTimestampStringNotDate,
  transformTimestampStringNotDateWhithOutHour,
});

export default function() {
  return result;
}

